import {
	AppBar,
	Box,
	Divider,
	Grid,
	List,
	ListItem,
	ListItemText,
	Paper,
	Tab,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Tabs,
} from "@material-ui/core";
import numeral from "numeral";
import PropTypes from "prop-types";
import React, { forwardRef, useImperativeHandle } from "react";

const AceiteConfirmacaoOrcamento = forwardRef((props, ref) => {
	const orcamento = JSON.parse(props.data.orcamento.json);
	const [value, setValue] = React.useState(0);
	// console.log("data", props.data);
	useImperativeHandle(ref, () => ({
		advanceHandler() {
			return true;
		},
	}));

	function TabPanel(props) {
		const { children, value, index, ...other } = props;

		return (
			<div
				role="tabpanel"
				hidden={value !== index}
				id={`simple-tabpanel-${index}`}
				aria-labelledby={`simple-tab-${index}`}
				{...other}
			>
				{value === index && <Box p={3}>{children}</Box>}
			</div>
		);
	}

	TabPanel.propTypes = {
		children: PropTypes.node,
		index: PropTypes.any.isRequired,
		value: PropTypes.any.isRequired,
	};

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<React.Fragment>
			{props.data.success && (
				<Grid container spacing={3}>
					<Grid item xs={4}>
						<Paper>
							<List>
								<ListItem>
									<ListItemText
										primary="Número do orçamento"
										secondary={props.data.orcamento.numero}
									/>
								</ListItem>
								<Divider component="li" />
								<ListItem>
									<ListItemText
										primary="Nome da pessoa"
										secondary={props.data.orcamento.cliente_nome}
									/>
								</ListItem>
								<Divider component="li" />
								<ListItem>
									<ListItemText
										primary="Nome do consultor"
										secondary={props.data.orcamento.consultor_nome}
									/>
								</ListItem>
								<Divider component="li" />
								<ListItem>
									<ListItemText
										primary="Total sem desconto"
										secondary={numeral(
											props.data.orcamento.total_sem_desconto
										).format("$ 0,0.00")}
									/>
								</ListItem>
								<Divider component="li" />
								<ListItem>
									<ListItemText
										primary="Porcentagem de desconto"
										secondary={numeral(props.data.orcamento.desconto).format(
											"0[.]00"
										)}
									/>
								</ListItem>
								<Divider component="li" />
								<ListItem>
									<ListItemText
										primary="Total com desconto"
										secondary={numeral(
											props.data.orcamento.total_com_desconto
										).format("$ 0,0.00")}
									/>
								</ListItem>
								<Divider component="li" />
								<ListItem>
									<ListItemText
										primary="Entrada"
										secondary={numeral(
											parseFloat(props.data.orcamento.entrada)
										).format("$ 0,0.00")}
									/>
								</ListItem>
							</List>
						</Paper>
					</Grid>
					<Grid item xs={8}>
						<Paper>
							<AppBar position="static">
								<Tabs value={value} onChange={handleChange}>
									<Tab label="Produtos do orçamento" />
									<Tab label="Produtos do Totvs" />
								</Tabs>
							</AppBar>
							<TabPanel value={value} index={0} className="aaaaa">
								<Table>
									<TableHead>
										<TableRow>
											<TableCell>Qtd</TableCell>
											<TableCell>Produto</TableCell>
											<TableCell align="right">Valor</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{orcamento.produtos.map((produto) => {
											const quantidade = produto.amount
												? produto.amount
												: produto.quantidade;
											const nome = produto.name ? produto.name : produto.nome;
											const valor_final = produto.value
												? produto.value
												: produto.valor_unitario * quantidade;
											return (
												<TableRow key={produto.id + "-orcamento"}>
													<TableCell>{quantidade}</TableCell>
													<TableCell>{nome}</TableCell>
													<TableCell align="right">
														{numeral(valor_final).format("$0,0.00")}
													</TableCell>
												</TableRow>
											);
										})}
									</TableBody>
								</Table>
							</TabPanel>
							<TabPanel value={value} index={1}>
								<Table>
									<TableHead>
										<TableRow>
											<TableCell>Qtd</TableCell>
											<TableCell>Produto </TableCell>
											<TableCell align="right">Valor</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{props.data.produtos.map((produto) => {
											return (
												<TableRow key={produto.cProduto + "-orcamento"}>
													<TableCell>{produto.nQuantidade}</TableCell>
													<TableCell>
														{produto.nome}-{produto.cProduto}
													</TableCell>
													<TableCell align="right">
														{numeral(produto.nValorVenda).format("$0,0.0000")}
													</TableCell>
												</TableRow>
											);
										})}
									</TableBody>
								</Table>
							</TabPanel>
						</Paper>
					</Grid>
				</Grid>
			)}
		</React.Fragment>
	);
});

export default AceiteConfirmacaoOrcamento;
